import React from 'react';
import type { AvailableLocales } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import { getGdprUrl } from '@eliadmin/core/src/utils/gdpr-tos/get-tos-gdpr-url';

type GdprCartSummaryProps = {
  locale: AvailableLocales;
};

export const GdprCartSummary = ({ locale }: GdprCartSummaryProps) => {
  const GDPRhref = getGdprUrl();

  const GDPRLink = ({ text, href }: { text: string; href?: string }) => (
    <Link
      href={href ?? GDPRhref}
      className={cn('text-primary', 'ea-cart-summary__gdpr-link')}
      prefetch={false}
    >
      {text}
    </Link>
  );

  switch (locale) {
    case 'sk':
      return (
        <span className={cn('', 'ea-cart-summary__gdpr-text')}>
          Potvrdzujem, že som sa oboznámil/a s{' '}
          <GDPRLink text="podmienkami spracúvania mojich osobných údajov" />.
        </span>
      );
    case 'cs':
      return (
        <span className={cn('', 'ea-cart-summary__gdpr-text')}>
          Potvrzuji, že jsem se seznámil/a s{' '}
          <GDPRLink text="podmínkami zpracování mých osobních údajů" />.
        </span>
      );
    case 'hu':
      return (
        <span className={cn('', 'ea-cart-summary__gdpr-text')}>
          Megerősítem, hogy elolvastam a{' '}
          <GDPRLink text="személyes adatok kezelésének feltételeit" />.
        </span>
      );
    default:
      return null;
  }
};

export const getGdprErrorText = (locale: AvailableLocales) => {
  switch (locale) {
    case 'sk':
      return 'Musíte súhlasiť s podmienkami spracúvania osobných údajov.';
    case 'cs':
      return 'Musíte súhlasit s podmínkami zpracování osobních údajů.';
    case 'hu':
      return 'Musálja elfogadni a elfogadja a feltételeit.';
    default:
      return null;
  }
};
